import { useMemo, useRef } from 'react';
import { ReactFeedbackContext, type FeedbackContextRecord, type FeedbackContextRegistry } from './feedbackContextStore';

// FIN-869: consultant-app copy of packages/ui/feedback/FeedbackContextProvider.tsx, kept
// separate rather than imported — src/ runs React 18, packages/ui links React 19 as a peer,
// so importing its component would load two Reacts.

export function FeedbackContextProvider({ children }: { children: React.ReactNode }) {
  const registryRef = useRef<Map<string, FeedbackContextRecord>>(new Map());

  const api = useMemo<FeedbackContextRegistry>(() => ({
    register: (id, value) => {
      registryRef.current.set(id, value);
    },
    unregister: (id) => {
      registryRef.current.delete(id);
    },
    getContext: () => {
      const merged: FeedbackContextRecord = {};
      for (const value of registryRef.current.values()) {
        Object.assign(merged, value);
      }
      return merged;
    },
  }), []);

  return <ReactFeedbackContext.Provider value={api}>{children}</ReactFeedbackContext.Provider>;
}
